module.exports = __webpack_public_path__ + "img/loginboxbag.b3c6f8bc.png";